// extracted by mini-css-extract-plugin
export default {"label":"WUo4oMsEtKc1zhTDd36o"};